import { useRef, useState, useEffect } from "react";
import "./HowWeDoIt.css";

export default function HowWeDoIt({
    id = "how-we-do-it",
    title = "Quiénes somos",
    steps = [
        {
            icon: "/img/assets/1.svg",
            title: "Conexiones",
            text: "Conectamos marcas con estudiantes universitarios de toda la región.",
        },
        {
            icon: "/img/assets/2.svg",
            title: "Experiencias",
            text: "Ejecutamos activaciones con métricas de impacto reales.",
        },
        {
            icon: "/img/assets/3.svg",
            title: "Comunidad",
            text: "Creamos y potenciamos una comunidad física y digital.",
        },
        {
            icon: "/img/assets/4.svg",
            title: "Escala",
            text: "Medimos resultados y optimizamos cada campaña.",
        },
    ],
}) {
    const trackRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        const handleScroll = () => {
            const i = Math.round(track.scrollLeft / track.clientWidth);
            setActiveIndex(i);
        };
        track.addEventListener("scroll", handleScroll, { passive: true });
        return () => track.removeEventListener("scroll", handleScroll);
    }, []);

    const goTo = (i) => {
        const track = trackRef.current;
        if (!track) return;
        track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
    };

    return (
        <section id={id} className="how">
            <div className="how-inner">
                <h2 className="how-title">{title}</h2>

                {/* Desktop grid */}
                <ul className="how-grid" aria-label="Modus Operandi">
                    {steps.map((step, i) => (
                        <li className="how-item" key={i}>
                            <div className="how-icon-wrap">
                                <img src={step.icon} alt="" aria-hidden="true" className="how-icon" />
                            </div>
                            <div className="how-body">
                                <h3 className="how-card-title">{step.title}</h3>
                                <p className="how-text">{step.text}</p>
                            </div>
                        </li>
                    ))}
                </ul>

                {/* Mobile slider */}
                <div className="how-swiper">
                    <ul className="how-track" ref={trackRef}>
                        {steps.map((step, i) => (
                            <li className="how-slide" key={i}>
                                <div className="how-icon-wrap">
                                    <img src={step.icon} alt="" aria-hidden="true" className="how-icon" />
                                </div>
                                <div className="how-body">
                                    <h3 className="how-card-title">{step.title}</h3>
                                    <p className="how-text">{step.text}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="how-dots">
                        {steps.map((_, i) => (
                            <button
                                key={i}
                                className={`how-dot ${activeIndex === i ? "is-active" : ""}`}
                                aria-label={`Ir a ${steps[i].title}`}
                                onClick={() => goTo(i)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
